import { useState } from 'react'

import * as Analytics from '~/lib/analytics'

type Values = {
  id: string
  name: string
}[]

export function useLabelsToggle(values: Values) {
  const [activeMode, setActiveMode] = useState(values[0].id)
  const onToggleClick = () => {
    if (values.length === 1) {
      return
    }

    const newActiveMode = activeMode === values[0].id ? values[1].id : values[0].id
    setActiveMode(newActiveMode)

    Analytics.addBreadcrumb(Analytics.BreadcrumbsTypes.TOGGLED_LABEL, { activeMode: newActiveMode })
  }

  return { onToggleClick, activeMode, setActiveMode }
}
